module.exports = __webpack_public_path__ + "static/media/External Link.5b5035c3.svg";